
  import { computed, defineComponent } from 'vue';
  import { Icon } from '@/ui/components/icon/Icon';
  import { TOTAL_STEPS } from '@/entities/onboarding';

  interface BackButtonProps {
    step: number;
  }

  export default defineComponent<BackButtonProps>({
    components: { Icon },
    props: ['step'],
    emits: ['click'],
    setup(props) {
      const isLastStep = computed(() => props.step >= TOTAL_STEPS);

      return {
        isLastStep,
      };
    },
  });
